import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getAVbokaMoteByUserid,setofUpdatedashboardBokaTV,decrypt,encrypt } from 'actions'
import {isUndefined} from 'lodash'
import {Grid} from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton';
import axios from 'util/ApiDashboard'
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
    const { updatedashboardBokaTY } = accountsData 
    const { AVbokaMote,DashboardAnpassadFilterOption} = DashBoard;
    return {
        authUser,AVbokaMote,DashboardAnpassadFilterOption,updatedashboardBokaTY
    };
}
function mapDispatchToProps(dispatch) {
    return {
        getAVbokaMoteByUserid: (userid,Afid,DashboardAnpassadFilterOption, intervaltype) => dispatch(getAVbokaMoteByUserid(userid,Afid,DashboardAnpassadFilterOption, intervaltype)),
        setofUpdatedashboardBokaTV: () => dispatch(setofUpdatedashboardBokaTV()),
      
        dispatch
    }
}


class Abonnemang extends Component {
    state={
        AVbokaMote:0,
        DashboardAnpassadFilterOption:[],
        done: true
    }
    intervalID = null
    componentDidMount=()=>{
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        axios.get(`kontos/DashBoard/getAVBMOBU`,
        { params:encrypt(JSON.stringify({
            Afid:Afid,
            FilterOption:[],
            intervaltype:this.props.intervaltype,
            userid:userid
          }))
        })
        .then(res => {
            if(res.data.success){
                let endata = decrypt(res.data.encryptedData,res.data.iv)
                let ndate = JSON.parse(endata)
                this.setState({ 
                    AVbokaMote:ndate.results.AVbokaMote
                 });
                    this.initiateInterval() 
                 //   this.setState({done: true})    
            }
        })
    }
    initiateInterval() {
        clearInterval(this.intervalID);
        this.intervalID= null
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){            
                   // this.setState({done: false})  
                const userid = this.props.authUser.user_id;
                const Afid = this.props.authUser.user_Afid;
                axios.get(`kontos/DashBoard/getAVBMOBU`,
        { params:encrypt(JSON.stringify({
            Afid:Afid,
            FilterOption:[],
            intervaltype:this.props.intervaltype,
            userid:userid
          }))
        })
        .then(res => {
            if(res.data.success){
                let endata = decrypt(res.data.encryptedData,res.data.iv)
                let ndate = JSON.parse(endata)
                this.setState({ 
                    AVbokaMote:ndate.results.AVbokaMote
                 });
                    this.initiateInterval() 
                 //   this.setState({done: true})    
            }
           
        })
            }
            },
            180000
        );
        
    }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID= null
    }
    componentDidUpdate=()=>{
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        if(parseInt(this.props.updatedashboardBokaTY) === 1){
            axios.get(`kontos/DashBoard/getAVBMOBU`,
        { params:encrypt(JSON.stringify({
            Afid:Afid,
            FilterOption:[],
            intervaltype:this.props.intervaltype,
            userid:userid
          }))
        })
        .then(res => {
            if(res.data.success){
                let endata = decrypt(res.data.encryptedData,res.data.iv)
                let ndate = JSON.parse(endata)
                this.setState({ 
                    AVbokaMote:ndate.results.AVbokaMote
                 });
                    this.initiateInterval() 
                 //   this.setState({done: true})    
            }
        })
            this.props.setofUpdatedashboardBokaTV()
        }
     
    }
    formatNumber=(number)=>{
        if(number > 1000000){
            return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
        }else if(number >= 1000){
            return `${(number/1000).toFixed(0)}K`
        }else{
            return number
        }
   }
    render() {
        //const formatter = new Intl.NumberFormat('fr',{ notation: "compact" , compactDisplay: "short" })
        return (<>
            {
                this.state.done === false?
                <Skeleton variant="rectangular"  height={'66%'} style={{margin:10,backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                :
            <div className="text-center h-100" style={{ color: 'white' }}>
              <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="center"
              className='h-100'
              >
                <Grid item style={{width: "155px"}}>
                <h2 style={{
                    fontSize: this.props.isFrom === 1 ? "12px" : "14px",margin: "5px",fontWeight:"300",textAlign: "left",
                marginLeft: "10px",color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}><b><IntlMessages id="DashBoard.Event.Canceled"/></b></h2>
                </Grid>
                <Grid item>
                <h2 className="display-4" 
                style={{ fontSize: 25,  margin: 'auto 10px',fontWeight:"500",color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor }}>
                    {this.formatNumber(this.state.AVbokaMote)}
                    <small style={{fontSize:12}}>/{this.props.getIntervalTypeText(this.props.intervaltype).slice(0,parseInt(this.props.intervaltype) === 2?4:3)}</small>
                </h2>
                </Grid>
            </Grid>
        </div>
    }</>
        )
    }
}
export default connect(
    mapStateToProps,mapDispatchToProps
)(Abonnemang);